import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const sunburstChartDescription: CalculatorDescription = {
  id: CalculatorId.SunburstChart,
  title: 'Sunburst Chart Maker',
  metaTitle: 'Online Sunburst Chart Maker - Create Hierarchical Visualizations',
  description: 'Create professional sunburst charts to visualize hierarchical data and nested relationships. Perfect for displaying multi-level categories, file systems, and organizational structures.',
  metaDescription: 'Make professional sunburst charts online. Visualize hierarchical data with our free sunburst diagram generator. Perfect for showing nested relationships and multi-level structures.',
  howTo: {
    title: 'How to Create a Sunburst Chart',
    steps: [
      'Enter hierarchical data with category paths (e.g., Parent/Child/Grandchild)',
      'Select the value column for sizing segments',
      'Customize chart radius and appearance',
      'Configure label display options',
      'Set title and finalize visualization'
    ],
    graphic: {
      description: 'An echarts sunburst chart with interactive segments, customizable levels, and hierarchical data display'
    }
  },
  examples: [
    {
      title: 'Product Category Analysis',
      description: 'Hierarchical sales distribution',
      dataDescription: 'Sales data across product categories and subcategories',
      insights: [
        'Visualize category hierarchies',
        'Compare sales across levels',
        'Identify top performers',
        'Analyze market segments'
      ]
    },
    {
      title: 'Organizational Structure',
      description: 'Department and team hierarchy',
      dataDescription: 'Employee distribution across departments and teams',
      insights: [
        'Show organizational levels',
        'Display team sizes',
        'Highlight department structure',
        'Track resource allocation'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.PieChart,
    CalculatorId.DonutChart,
    CalculatorId.NightingaleChart,
    CalculatorId.BarGraph
  ]
}; 